import {IPeriodicEmailSettings} from "../setting-types/periodic-email-settings";

/* Used for request/response and for user values and system default values
 * as the property names are common across each */
export class UserPreferencesData {

  SendEmailOnFormAssignment: boolean;
  DisplayNonCurrentManagers: boolean;
  SkipListerPage: boolean;
  DisplayObsoleteUnits: boolean;
  PeriodicEmailSettings: IPeriodicEmailSettings;
  FormCompletionNavigation: string;
  DisplayNonCurrentLeasesAndTenants: boolean;
  DisplayNonCurrentHeadLeasesAndLandlords: boolean;

  constructor(
    sendEmailOnFormAssignment: boolean,
    displayNonCurrentManagers: boolean,
    skipListerPage: boolean,
    displayObsoleteUnits: boolean,
    periodicEmailSettings: IPeriodicEmailSettings,
    formCompletionNavigation: string,
    displayNonCurrentLeasesAndTenants: boolean,
    displayNonCurrentHeadLeasesAndLandlords: boolean) {
    this.SendEmailOnFormAssignment = sendEmailOnFormAssignment;
    this.DisplayNonCurrentManagers = displayNonCurrentManagers;
    this.SkipListerPage = skipListerPage;
    this.DisplayObsoleteUnits = displayObsoleteUnits;
    this.PeriodicEmailSettings = periodicEmailSettings;
    this.FormCompletionNavigation = formCompletionNavigation;
    this.DisplayNonCurrentLeasesAndTenants = displayNonCurrentLeasesAndTenants;
    this.DisplayNonCurrentHeadLeasesAndLandlords = displayNonCurrentHeadLeasesAndLandlords;
  }
}
